import React from 'react';

import { Skeleton } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';

interface CompanyDetailPointListProps {
    icon: React.ReactNode;
    label: string;
    value?: string | number | null;
    isLoading: boolean;
}

const CompanyDetailPointList = ({ icon, label, value, isLoading }: CompanyDetailPointListProps) => {
    return (
        <div className="text-muted-foreground flex w-full flex-row gap-1">
            {icon}
            <div className="flex w-full flex-col gap-1">
                <span className="text-xs">{label}</span>
                <span className="text-foreground text-xs">
                    {isLoading ? <Skeleton className="h-4 w-16" /> : value || UIStrings.NA}
                </span>
            </div>
        </div>
    );
};

export default CompanyDetailPointList;
